'use client';

import { Flex } from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';
import { MdOutlineBusinessCenter } from 'react-icons/md';

import { useJobOccupationsSelectorState } from '@/modules/shared/presentation/hooks/useJobOccupationsSelectorState';

import { CategorySelectDialog } from '../CategorySelectorDialog/CategorySelectorDialog';

type SelectorDialogProps = PropsWithChildren<{
	count?: number
}>;

export const JobOccupationsSelectorDialog = ({ children, count = 0 }: SelectorDialogProps) => {
	const {
		categories,
		collections,
		handleToggle,
		isLoading,
		selectedIds,
		setGroup,
	} = useJobOccupationsSelectorState();

	return (
		<CategorySelectDialog.Root>
			<CategorySelectDialog.Trigger asChild>
				{children}
			</CategorySelectDialog.Trigger>
			<CategorySelectDialog.Content>
				<CategorySelectDialog.CloseIcon />
				<CategorySelectDialog.Header icon={MdOutlineBusinessCenter} title="Job Occupations" />
				<CategorySelectDialog.Body as={Flex} direction="row">
					<CategorySelectDialog.SideBar
						groups={categories}
						onSelectGroup={setGroup}
					/>
					<CategorySelectDialog.Checklist
						collections={collections}
						isLoading={isLoading}
						onSelect={handleToggle}
						selectedIds={selectedIds}
					/>
				</CategorySelectDialog.Body>
				<CategorySelectDialog.Footer>
					<CategorySelectDialog.ActionButton count={count} label="Select" />
				</CategorySelectDialog.Footer>
			</CategorySelectDialog.Content>
		</CategorySelectDialog.Root>
	);
};
